export const iconFontAwesomeShapesCloud = (
	<i className="fa-solid fa-cloud"></i>
);
